import { ExternalLinkIcon } from 'lucide-react'
import { ContentDetailLink } from './'

type PropsType = {
  href?: string | null
  title?: string
  external?: boolean
}

const TranslatedContentDetailLink = ({ href, title, external = true }: PropsType) => {
  return (
    <div className="flex flex-row items-center gap-1">
      <ExternalLinkIcon className="h-4 w-4" />
      {href ? <ContentDetailLink href={href} title={title} external={external} /> : <span>-</span>}
    </div>
  )
}

export default TranslatedContentDetailLink
